import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
providedIn: 'root'
})
export class CredentialsService {
    constructor(private httpClient: HttpClient) {
    }

    public getWhatsappLink() {
        let url = environment.apiUrl + '/site/credentials/whatsapp';
        return this.httpClient.get(url);
    }
}